import { Component, OnInit } from '@angular/core';
// Module
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// Service
import { BroadcastService, ObjectUtils, ReactiveFormUtils, ToasterType } from '@cv-invision/core';
import { GenericFormService } from '@cv-invision/cv.invision-views.ux';
import { QualityDocumentService } from '../../../../service/document-quality.service';
// Model
import { OrderDetailModel } from '../../../../state/model/order-detail.model';
import { UcdpHardstopsDataModel, UcdpSumissionDataModel } from '../../../../model/ucdp.model';
import { UCDP_OVERRIDE_FORM } from './model/ucdp-override.form.model';
import { FormGroup } from '@angular/forms';

@Component({
	selector: 'cv-ucdp-override-dialog',
	templateUrl: 'ucdp-override-dialog.component.html'
})
export class UcdpOverrideDialogComponent implements OnInit {
	orderDetail!: OrderDetailModel;
	submission!: UcdpSumissionDataModel;
	hardStop!: UcdpHardstopsDataModel;

	hardstopCodes;
	isFormReady = false;
	isSubmitting = false;

	get form(): FormGroup {
		return this.genericFormService.form;
	}

	private atComponentDestroy = new Subject();

	constructor(
		public dialogRef: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private broadcastService: BroadcastService,
		private qualityService: QualityDocumentService,
		private genericFormService: GenericFormService
	) {
		this.orderDetail = this.dialogConfig.data.orderDetail;
		this.submission = this.dialogConfig.data.submission;
		this.hardStop = this.dialogConfig.data.hardStop;
	}

	ngOnInit(): void {
		const formConfig = ObjectUtils.recursiveDeepCopy(UCDP_OVERRIDE_FORM);
		this.genericFormService.setFormFieldList(formConfig);
		this.genericFormService.initForm({
			reasonCode: null,
			commentRequired: false,
			comment: null
		});

		this.loadData();

		this.genericFormService.formObserver.pipe(takeUntil(this.atComponentDestroy)).subscribe((data) => {
			if (data) {
				this.isFormReady = true;
				this.genericFormService.form.markAsPristine();
			}
		});

		this.genericFormService.onChangeOptions$.pipe(takeUntil(this.atComponentDestroy)).subscribe((data: any) => {
			const field = data.field;

			if (field.UIEvents.onChange) {
				field.UIEvents.onChange(
					data.event,
					this.genericFormService.formFieldList,
					this.genericFormService.form,
					field
				);
			}
		});
	}

	/**
	 * Load hardstops codes from API and add them to the dropdown options
	 */
	async loadData(): Promise<void> {
		const hardstop = this.hardStop.hardstop;
		const options = await lastValueFrom(this.qualityService.getHardStopCodes(hardstop, this.submission.service));
		if (options.length) {
			this.hardstopCodes = options;
			this.genericFormService.formFieldList['reasonCode'].options = options.map((item: any) => {
				return {
					label: item['description'],
					value: item['reasonCode'],
					commentRequired: item['commentRequired']
				};
			});
		}
	}

	/**
	 * Submit the override data
	 */
	submit(): void {
		this.isSubmitting = true;
		this.qualityService
			.postReasonCode(
				this.orderDetail.id,
				this.submission.submissionId,
				this.hardStop.id,
				this.genericFormService.form.value
			)
			.subscribe({
				next: (data) => {
					if (data.isValid) {
						this.isSubmitting = false;
						this.dialogRef.close({ reloadFindings: true });
					} else {
						this.isSubmitting = false;
					}
				},
				error: (err) => {
					this.isSubmitting = false;
				}
			});
	}
}
